var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  SamaForm: () => SamaForm
});
var import_definition = __toModule(require("../definition"));
var import_screenInfo = __toModule(require("../screen/screenInfo"));
var import_screenYayoyaki = __toModule(require("../screen/screenYayoyaki"));
var import_addMapper = __toModule(require("../summary/forms/addMapper"));
var import_screenAdd = __toModule(require("../screen/screenAdd"));
var import_screenClassify = __toModule(require("../screen/screenClassify"));
var import_screenSummaryFactory = __toModule(require("../summary/screenSummaryFactory"));
var import_screenWrapperFactory = __toModule(require("../../kamiSama/screen/wrapper/screenWrapperFactory"));
var import_screenFilterSingleoption = __toModule(require("../../kamiSama/screen/screenFilterSingleoption"));
class SamaForm {
  constructor(samaDictionary) {
    var _a, _b, _c, _d, _e;
    this.screenMap = (_a = samaDictionary == null ? void 0 : samaDictionary.screenForm) == null ? void 0 : _a.dictionary;
    this.yayoyakiMap = (_b = samaDictionary == null ? void 0 : samaDictionary.yayoyakiForm) == null ? void 0 : _b.dictionary;
    this.optionMap = (_c = samaDictionary == null ? void 0 : samaDictionary.optionForm) == null ? void 0 : _c.dictionary;
    this.cardMap = (_d = samaDictionary == null ? void 0 : samaDictionary.cardForm) == null ? void 0 : _d.dictionary;
    this.sectionMap = (_e = samaDictionary == null ? void 0 : samaDictionary.sectionForm) == null ? void 0 : _e.dictionary;
    this.setForm(this.screenMap);
  }
  getYayoyakiMapForSection(section) {
    var _a, _b, _c, _d, _e, _f, _g;
    const yayoyakiFormMap = {};
    for (const screenId in this.screenMap) {
      if (((_a = this.screenMap[screenId]) == null ? void 0 : _a.section) !== section) {
        continue;
      }
      if ((_b = this.screenMap[screenId]) == null ? void 0 : _b.yayoyakiSiblingsId) {
        for (const yayoyakiId of (_c = this.screenMap[screenId]) == null ? void 0 : _c.yayoyakiSiblingsId) {
          const yayoyakiForm = this.getYayoyakiForm(yayoyakiId);
          yayoyakiFormMap[yayoyakiId] = (_d = yayoyakiFormMap[yayoyakiId]) != null ? _d : yayoyakiForm;
        }
        continue;
      }
      if ((_e = this.screenMap[screenId]) == null ? void 0 : _e.yayoyakisId) {
        for (const yayoyakiId of (_f = this.screenMap[screenId]) == null ? void 0 : _f.yayoyakisId) {
          const yayoyakiForm = this.getYayoyakiForm(yayoyakiId);
          yayoyakiFormMap[yayoyakiId] = (_g = yayoyakiFormMap[yayoyakiId]) != null ? _g : yayoyakiForm;
        }
        continue;
      }
    }
    return yayoyakiFormMap;
  }
  getYayoyakiMap() {
    return this.yayoyakiMap;
  }
  getCardMap() {
    return this.cardMap;
  }
  getCardGroupForm(cardGroupFormId) {
    var _a;
    for (const screenId in this.screenMap) {
      if ((_a = this.screenMap[screenId]) == null ? void 0 : _a.cardsId) {
        const found = this.getCardForm(cardGroupFormId);
        if (found) {
          return found;
        }
      }
    }
  }
  getForm() {
    return this.screenMap;
  }
  getScreen(samaData, screenId, navigationIndex) {
    if (import_addMapper.AddMapper.isScreenAdd(screenId)) {
      return new import_screenAdd.ScreenAdd(samaData, this, screenId);
    }
    if (this.screenMap[screenId].screenType === import_definition.ScreenTypes.SUMMARY) {
      this.summaryParentIndex = void 0;
    }
    if (this.screenMap[screenId].screenType === import_definition.ScreenTypes.SUBSUMMARY_FILTERED) {
      if (this.summaryParentIndex !== void 0) {
        navigationIndex = this.summaryParentIndex;
      } else {
        this.summaryParentIndex = navigationIndex;
      }
    }
    if (this.screenMap[screenId].screenType === import_definition.ScreenTypes.SUMMARY_CLASIFICATOR) {
      return new import_screenClassify.ScreenClassify(samaData, this, screenId, navigationIndex);
    }
    if (this.screenMap[screenId].screenType === import_definition.ScreenTypes.FILTER_SINGLEOPTION) {
      return new import_screenFilterSingleoption.ScreenFilterSingleoption(samaData, this, screenId, navigationIndex);
    }
    if (this.screenMap[screenId].screenType === import_definition.ScreenTypes.WRAPPER) {
      return import_screenWrapperFactory.ScreenWrapperFactory.build(samaData, this, screenId, navigationIndex);
    }
    if (this.screenMap[screenId].cardsId) {
      return import_screenSummaryFactory.ScreenSummaryFactory.createSummary(samaData, this, screenId, navigationIndex);
    }
    if (this.screenMap[screenId].yayoyakisId) {
      return new import_screenYayoyaki.ScreenYayoyaki(samaData, this, screenId, navigationIndex);
    }
    return new import_screenInfo.ScreenInfo(samaData, this, screenId, navigationIndex);
  }
  getScreenForm(screenId) {
    return this.screenMap[screenId];
  }
  getYayoyakiForm(yayoyakiId) {
    return this.yayoyakiMap[yayoyakiId];
  }
  getOptionsForm(optionId) {
    return this.optionMap[optionId];
  }
  getCardForm(cardGroupId) {
    return this.cardMap[cardGroupId];
  }
  getYayoyakisArrayForm(yayoyakisId) {
    const yayoyakisFormArray = [];
    for (const yayoyakiId of yayoyakisId) {
      const yayoyakiForm = this.getYayoyakiForm(yayoyakiId);
      if (yayoyakiForm) {
        yayoyakisFormArray.push(yayoyakiForm);
      }
    }
    return yayoyakisFormArray;
  }
  getScreenNext(samaData, current) {
    const next = this.getScreen(samaData, current.getNext(), current.getNavigationIndex());
    if ((next == null ? void 0 : next.isSummary()) && current.isChild()) {
      const card = this.getCardForm(current.getCardId());
      if ((card == null ? void 0 : card.reviewable) && (card == null ? void 0 : card.childrenScreenId) === next.getId()) {
        samaData.setUserCardsCacheValue(current.getCardId(), current.getNavigationIndex());
      }
    }
    if (typeof next === "undefined") {
      return;
    }
    if (next.isShow()) {
      return next;
    }
    return this.getScreenNext(samaData, next);
  }
  getScreenPrevious(samaData, current) {
    const previous = this.getScreen(samaData, current.getPrevious(), current.getNavigationIndex());
    if (typeof previous === "undefined") {
      return;
    }
    if (previous.isShow()) {
      return previous;
    }
    return this.getScreenPrevious(samaData, previous);
  }
  getYayoyakisForSection(section) {
    const yayoyakiFormMap = this.getYayoyakiMapForSection(section);
    return Object.values(yayoyakiFormMap);
  }
  getYayoyakis() {
    const sections = this.getSections();
    let yayoyakiFormMap = {};
    for (const section of sections) {
      const yayoyakiFormSectionMap = this.getYayoyakiMapForSection(section);
      yayoyakiFormMap = __spreadValues(__spreadValues({}, yayoyakiFormMap), yayoyakiFormSectionMap);
    }
    return yayoyakiFormMap;
  }
  getSections() {
    var _a;
    const sections = new Set();
    for (const screenId in this.screenMap) {
      if ((_a = this.screenMap[screenId]) == null ? void 0 : _a.yayoyakisId) {
        sections.add(this.screenMap[screenId].section);
      }
    }
    return Array.from(sections);
  }
  setForm(screenMap) {
    if (!screenMap) {
      throw new Error("SenninForm.setForm: screenForms is undefined");
    }
    this.screenMap = screenMap;
  }
  getSectionsOrdered() {
    return [...Object.keys(this.sectionMap)];
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SamaForm
});
